module.exports = __webpack_public_path__ + "static/media/maker-migration.bc301e33.png";